import { render, staticRenderFns } from "./ForgotPassword2FA.vue?vue&type=template&id=9cba46b2&"
import script from "./ForgotPassword2FA.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports